<template lang="pug">
	.error-notification(v-if="showed")
		.card
			.card-header
				i.fa.fa-exclamation
				span {{title}}
			.card-body.collapse.show
				.form-horizontal
					span {{error}}
			.card-footer
				button.btn.btn-secondary(@click="hide()") Close

</template>

<script>

	import Screen 				from './../../mixins/screen';

	export default {
		name: "ErrorNotification",
		mixins: [Screen],
		screen: {
			updateOn: [],
			showed: false
		},
		data() {

			return {
				title: '',
				error: ''
			}
		},
		methods: {
			collectData(action, ...params) {

				this.title = params[0];
				this.error = params[1];


			},
		}
	}
</script>


<style lang="sass">

	.error-notification
		position: absolute
		z-index: 2000
		background-color: rgba(0, 0, 0, 0.6)
		display: flex
		align-items: center
		justify-content: center
		width: 100%
		height: 100%

		.card
			width: 500px
			box-shadow: 0px 0px 20px rgba(0, 0, 0, 0.8)

			>.card-header
				color: red

			>.card-footer
				display: flex
				justify-content: end
				background: #343b41
				border-top: 1px solid #23282c


</style>

